// ===== 慣性スクロール（Lenis・このページのみ）=====
// ネイティブのスクロール位置を動かす方式なので、MV のパララックスや text-pin の sticky/scroll 計算はそのまま動く。
// タッチ端末は標準スクロールのまま（syncTouch 既定 false）。動きを減らす設定の人には使わない。
(() => {
  'use strict';
  if (!window.Lenis) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  window.neruLenis = new Lenis({
    lerp: 0.1,                  // 追従の滑らかさ（小さいほどゆっくり）
    autoRaf: true,
    allowNestedScroll: true,    // メニュー等、中でスクロールする要素はそのまま
    // ページ内リンクの止まる位置。ヘッダーは下スクロールで隠れる（on-scroll-up）のでヘッダー分は不要。
    // 120 だと 1st 見出しの上に 2nd の商品が覗いたので、見出し上の間隔（PC 約85px / SP 48px）に収まる 40（CSS の scroll-margin-top と同じ）
    anchors: { offset: -40 },
  });
})();

// ===== #アンカー付き URL で開いたときの位置合わせ =====
// ブラウザは読み込み途中でアンカーへ飛ぶが、その後に MV の下余白・text-pin の高さが JS で決まり位置がずれる。
// 読み込み完了後（レイアウト確定後）にもう一度合わせ直す。Lenis 有効時は Lenis で、無効時は scrollIntoView（scroll-margin-top を使う）。
(() => {
  'use strict';
  const target = () => {
    const id = decodeURIComponent(location.hash.slice(1));
    return id ? document.getElementById(id) : null;
  };
  const realign = () => {
    const el = target();
    if (!el) return;
    if (window.neruLenis) window.neruLenis.scrollTo(el, { offset: -40, immediate: true, force: true });
    else el.scrollIntoView({ block: 'start' });
  };
  window.addEventListener('load', () => setTimeout(realign, 150));
})();

/* Neru LP 改修版（2nd Collection）— 元記事 /blogs/feature/neru の本文内スクリプトを移したもの */
(() => {
  'use strict';
  const lead = document.querySelector('.neru-lead');
  if (!lead) return;

  // ページ表示と同時に1フレーム遅らせて開始（初期描画を確実に反映してから）
  requestAnimationFrame(() => {
    lead.classList.add('is-unmasked');
  });

  /* もし「画像読み込み完了後に開始したい」なら下を使う（上のrAFは外す）
  const img = lead.querySelector('.neru-lead-img img');
  const start = () => lead.classList.add('is-unmasked');
  if (img && !img.complete) img.addEventListener('load', () => requestAnimationFrame(start), { once:true });
  else requestAnimationFrame(start);
  */
})();

(() => {
  'use strict';

  const section = document.querySelector('.neru-lead');
  const img     = section?.querySelector('.neru-lead-img img');
  if (!img) return;

  const mq = window.matchMedia('(max-width: 768px)');
  const isMobile = () => mq.matches;

  const speed = 4.0; // ご希望のスピード感（下方向）

  // transformの影響を受けないdoc座標を取得
  const pageY = (el) => { let y = 0, e = el; while (e) { y += e.offsetTop; e = e.offsetParent; } return y; };

  let sectionPageTop = 0; // セクションのdoc座標（上端）
  let winH = 1;
  const pic  = img.closest('.neru-lead-img');
  const rate = 100 * speed;  // 1画面スクロールあたりの移動量(px)
  const roomRatio = .85;     // 下余白を計算値の何割にするか（1=下端ぴったり。2026-09-30「少し大きすぎる」で .85）

  // 画像は下へずれていくので、そのまま枠(overflow:hidden)に収めると下端(商品の足元)が切れる。
  // 「MV の下端が画面に入った瞬間に、画像の下端と枠の下端がぴったり揃う」だけの余白を下に足す。
  //   その時点の移動量 move = (T + 上余白 + 画像高 + P - winH) / winH * rate が P と等しくなる P を解く
  //   → P = (T + 上余白 + 画像高 - winH) * rate / (winH - rate)
  // 元の neru.css は padding-bottom を 40vw〜18vw の固定値で持っていたが、画面の高さで過不足が出るので計算する。
  const setRoom = () => {
    if (!pic) return;
    if (isMobile() || winH <= rate) { pic.style.paddingBottom = ''; return; }
    const padTop = parseFloat(getComputedStyle(pic).paddingTop) || 0;
    const need = (sectionPageTop + padTop + img.offsetHeight - winH) * rate / (winH - rate);
    pic.style.paddingBottom = Math.max(0, need * roomRatio).toFixed(0) + 'px';
  };

  const setBase = () => {
    pic && (pic.style.paddingBottom = '');
    sectionPageTop = pageY(section);
    winH = Math.max(1, window.innerHeight);
    setRoom();
  };

  // 画像と一緒に上端の帯(::before)も動かす（CSS 変数 --lead-move）
  const setMove = (px) => {
    img.style.transform = `translate3d(0, ${px}px, 0)`;
    section.style.setProperty('--lead-move', px + 'px');
  };

  const onScroll = () => {
    if (isMobile()) { setMove(0); return; }

    const scBottom  = window.scrollY + winH;               // ビューポート下端(doc座標)
    const baseOffset = Math.max(0, winH - sectionPageTop); // ★ 0スタート補正

    // 画面に入る前は常に0px
    if (scBottom <= sectionPageTop + baseOffset) {
      setMove(0);
      return;
    }

    // 進行度：0（開始）→ 1（1画面ぶん）…
    const progress = (scBottom - sectionPageTop - baseOffset) / winH;
    const move = Math.max(0, progress) * 100 * speed;      // 下方向に正で増える

    setMove(move.toFixed(2));
  };

  const onResize = () => { setBase(); onScroll(); };

  const init = () => { setBase(); onScroll(); };
  if (img.complete) init(); else img.addEventListener('load', init, { once:true });

  window.addEventListener('scroll', onScroll, { passive:true });
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);
})();

(() => {
  'use strict';

  // === 1) #nero-concept 内の .text をラップしてスクロール余白を確保 ===
  const concept = document.querySelector('#nero-concept');
  if (!concept) return;

  const textBlocks = [...concept.querySelectorAll('.text')];

  // AOSをこのブロックだけ無効化したいとき（pに data-aos が付いてたら外す）
  textBlocks.forEach(tb => {
    tb.querySelectorAll('[data-aos]').forEach(el => el.removeAttribute('data-aos'));
  });

  // まだ包まれていなければ .text-pin でラップ
  textBlocks.forEach(tb => {
    if (!tb.parentElement.classList.contains('text-pin')) {
      const pin = document.createElement('div');
      pin.className = 'text-pin';
      tb.parentNode.insertBefore(pin, tb);
      pin.appendChild(tb);
    }
  });

  // === 2) レイアウト計算：各 .text-pin の高さを「pの数 × 100vh」にする ===
  const setup = () => {
    const vh = window.innerHeight;
    textBlocks.forEach(tb => {
      const pin = tb.parentElement;
      const paras = [...tb.querySelectorAll('p')].filter(p => p.textContent.trim().length > 0);
      const steps = Math.max(1, paras.length);  // 通常は3
      // p を全部出し切るまで次へ進めないよう、(steps × 100vh) ぶんの余白を持たせる
      pin.style.height = (vh * steps) + 'px';
      pin.dataset.steps = String(steps);
    });
  };

  // === 3) スクロールに応じて p を段階的にフェードイン ===
  const lerp = (a, b, t) => a + (b - a) * t;
  const clamp01 = (x) => Math.max(0, Math.min(1, x));
  const ease = (t) => (t < 0) ? 0 : (t > 1) ? 1 : t * (2 - t); // ちょい緩やか

  const onScroll = () => {
    const y = window.scrollY;
    const vh = window.innerHeight;

    textBlocks.forEach(tb => {
      const pin = tb.parentElement;
      const steps = parseInt(pin.dataset.steps || '1', 10);
      const paras = [...tb.querySelectorAll('p')];

      // この .text-pin のローカルスクロール量（先頭がビューポート上端に来た時点を0）
      const start = pin.offsetTop;
      const end   = start + (vh * steps) - vh;    // stickyが解ける地点
      const sc    = clamp01((y - start) / Math.max(1, (end - start))); // 0〜1

      // 全体進行を 0..steps に拡大
      const g = sc * steps;

      // 各 p の進行度を計算：i段目は g が i を超えたところから1へ
      paras.forEach((p, i) => {
        // 段の入り〜終わりを 0..1 に正規化
        const t = clamp01(g - i);
        const k = ease(t);
        const opacity = k;                          // 0→1
        const ty = lerp(24, 0, k);                  // 24px→0px
        p.style.opacity = opacity.toFixed(3);
        p.style.transform = `translateY(${ty.toFixed(1)}px)`;
      });
    });
  };

  // === 4) rAF で軽量化 ===
  let ticking = false;
  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => { onScroll(); ticking = false; });
      ticking = true;
    }
  };

  // === 5) 初期化 ===
  const init = () => { setup(); onScroll(); };
  window.addEventListener('resize', () => { setup(); onScroll(); });
  window.addEventListener('orientationchange', () => { setup(); onScroll(); });
  window.addEventListener('scroll', handleScroll, { passive: true });

  // 画像読み込み後にサイズが変わることがあるので、遅延セットアップも一応
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();

(() => {
  'use strict';

  const run = () => {
    // AOS属性は競合するので外す（残っていれば）
    document.querySelectorAll('[data-aos]').forEach(el => el.removeAttribute('data-aos'));

    const targets = document.querySelectorAll('.reveal');
    if (!targets.length) return;

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        const el = e.target;
        const once = (el.dataset.once ?? 'true') !== 'false'; // 既定: 一度だけ
        if (e.isIntersecting) {
          const d = parseInt(el.dataset.delay || '0', 10) || 0; // ← アナログ指定
          el.style.setProperty('--delay', d + 'ms');
          el.classList.add('is-inview');
          if (once) io.unobserve(el);
        } else if (!once) {
          el.classList.remove('is-inview');
        }
      });
    }, { threshold: 0.15 });

    targets.forEach(el => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once:true });
  } else {
    run();
  }
})();
